import React from 'react';
import './Overlays.css'

// Helper to calculate match stakes symmetrically based on the current bid
function getProjectedPoints(bidAmount, mode) {
  if (mode === '56') {
      if (bidAmount >= 28 && bidAmount <= 39) return { w: 1, l: 1 };
      if (bidAmount >= 40 && bidAmount <= 55) return { w: 2, l: 2 };
      if (bidAmount === 56) return { w: 3, l: 3 };
  } else {
      if (bidAmount >= 14 && bidAmount <= 19) return { w: 1, l: 1 };
      if (bidAmount >= 20 && bidAmount <= 27) return { w: 2, l: 2 };
      if (bidAmount === 28) return { w: 3, l: 3 };
  }
  return { w: 1, l: 1 }; // Default fallback
}

function BidStakes({ bw, bl, currentBid, minValid }) {
  if (currentBid < minValid) return null;
  return (
    <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginBottom: 14 }}>
      <span style={{ fontSize: '0.8rem', color: '#6ee7b7', background: 'rgba(5,150,105,0.2)', padding: '3px 10px', borderRadius: 8 }}>
        Win +{bw}
      </span>
      <span style={{ fontSize: '0.8rem', color: '#fca5a5', background: 'rgba(220,38,38,0.15)', padding: '3px 10px', borderRadius: 8 }}>
        Lose −{bl}
      </span>
    </div>
  );
}

export default function BiddingPanel({ gs, myId, send }) {
  const [pendingBid, setPendingBid] = React.useState(null);

  const isMyTurn = gs.bid_turn === myId;
  const hasPassed = gs.passed_since_bid?.[myId];
  const isForced = gs.forced_bidder === myId;
  const currentBid = gs.current_bid;
  
  const is56 = gs.mode === '56';
  const minValidBid = is56 ? 28 : 14;
  const maxBid = is56 ? 56 : 28;
  const minBid = Math.max(minValidBid, currentBid + 1);
  
  const ObjectKeysBids = [];
  for (let b = minBid; b <= maxBid; b++) ObjectKeysBids.push(b);
  
  const bidderTurnName = gs.players?.[gs.bid_turn]?.name ?? '?';

  const hasValidBid = currentBid >= minValidBid;
  const currentBidderName = hasValidBid && gs.current_bidder >= 0 
    ? gs.players?.[gs.current_bidder]?.name || "Unknown Player" 
    : null;

  const projectedStakes = getProjectedPoints(currentBid, gs.mode);
  const bw = projectedStakes.w;
  const bl = projectedStakes.l;

  if (!isMyTurn && !isForced) {
    return (
      <div className="phase-panel">
        <h3>Bidding <span style={{ fontSize: '0.8rem', fontWeight: 'normal' }}>· Lelam</span></h3>
        <div className="bid-current">{hasValidBid ? currentBid : '—'}</div>
        
        {hasValidBid && (
          <p style={{ color: '#6ee7b7', marginBottom: 12 }}>
            Highest: <strong>{currentBidderName}</strong> @ {currentBid}
          </p>
        )}
        
        <p style={{ color: 'rgba(255,255,255,0.6)' }}>
          Waiting for <strong style={{ color: '#fcd34d' }}>{bidderTurnName}</strong>…
        </p>
        <BidStakes bw={bw} bl={bl} currentBid={currentBid} minValid={minValidBid} />
      </div>
    );
  }

  const handleBidClick = (b) => {
    const isHighBid = (is56 && b >= 40) || (!is56 && b >= 20);
    if (isHighBid) {
      setPendingBid(b);
    } else {
      send('bid', { amount: b });
    }
  };

  if (pendingBid !== null) {
    return (
      <div className="phase-panel">
        <h3 style={{ color: '#f87171' }}>Confirm High Bid</h3>
        <p style={{ color: '#fcd34d', fontSize: '1.2rem', margin: '15px 0' }}>
          Are you sure you want to bid <strong>{pendingBid}</strong>?
        </p>
        <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginBottom: '20px' }}>
          This is a high stakes bid!
        </p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <button 
            className="pass-btn"
            onClick={() => setPendingBid(null)}
          >
            Cancel
          </button>
          <button 
            className="glow-btn"
            style={{ padding: '8px 20px', fontSize: '1rem' }}
            onClick={() => {
              send('bid', { amount: pendingBid });
              setPendingBid(null);
            }}
          >
            Confirm {pendingBid}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="phase-panel">
      <h3>Your Bid {isForced && <span style={{ color: '#f87171', fontSize: '0.8rem' }}> · Forced</span>}</h3>
      <div className="bid-current">{hasValidBid ? currentBid : '—'}</div>
      
      {hasValidBid ? (
        <p style={{ color: '#94a3b8', marginBottom: 12, fontSize: '0.85rem' }}>
          To beat: <strong style={{ color: '#fcd34d' }}>{currentBid}</strong> by {currentBidderName}
        </p>
      ) : (
        <p style={{ color: '#94a3b8', marginBottom: 12, fontSize: '0.85rem' }}>
          No bids placed yet.
        </p>
      )}

      <BidStakes bw={bw} bl={bl} currentBid={currentBid} minValid={minValidBid} />
      
      {/* THE FIX: Removed the inline scroll trap! */}
      <div className="bid-buttons">
        {ObjectKeysBids.map(b => (
          <button key={b} className="bid-btn" onClick={() => handleBidClick(b)}>{b}</button>
        ))}
      </div>
      
      {!isForced && (
        <button className="pass-btn" onClick={() => send('pass_bid', {})}>
          Pass {hasPassed ? '(passed once)' : ''}
        </button>
      )}
      {isForced && (
        <p style={{ fontSize: '0.8rem', color: '#fcd34d', marginTop: 8 }}>
          You must bid (minimum {minBid})
        </p>
      )}
    </div>
  );
}